module.exports = __webpack_public_path__ + "static/media/puzzle-20-bg.790c3a2c.svg";